import { Directive, Input, HostBinding } from '@angular/core';
import { BaseDirective } from '../base/_base.directive';

@Directive({
  selector: '[searchIcon]',
  exportAs: 'search-icon'
})
export class SearchIconDirective extends BaseDirective {

  @HostBinding('class.icon') iconClass: boolean = true;

  @Input() set color(color: string) {
    this.setClassName(this.colorsMap[color]);
  }

  private colorsMap: any = {
    white: 'search-white-icon',
    grey: 'search-grey-icon'
  };

}
